import { render, staticRenderFns } from "./common-nav-box.vue?vue&type=template&id=4d369f7d&scoped=true"
import script from "./common-nav-box.vue?vue&type=script&lang=js"
export * from "./common-nav-box.vue?vue&type=script&lang=js"
import style0 from "./common-nav-box.vue?vue&type=style&index=0&id=4d369f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d369f7d",
  null
  
)

export default component.exports